import { useViewportInfoContext } from "@/src/contexts";
import type { Device, IViewportInfo } from "@Components/Modules/ViewportResize";

export interface IViewportWrapperRequiredProps {
    viewport: IViewportInfo;
    device: Device;
}

type IViewportWrapper<T extends {}> = {
    Component: React.ComponentClass<T & IViewportWrapperRequiredProps>;
    props: Exclude<T, IViewportWrapperRequiredProps>;
};

const ViewportWrapper = <T extends {}>({ Component, props }: IViewportWrapper<T>) => {
    const viewportInfo = useViewportInfoContext();
    return <Component {...props} viewport={viewportInfo} device={viewportInfo.device} />;
};

export default ViewportWrapper;
